import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ShowController, WithPermissions, useTranslate } from 'react-admin';
import { useMediaQuery } from '@mui/material';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: 'auto',
        margin: 'auto',
    },
    innergrid: {
        maxWidth: 500,
        minHeight: 40,
    },
    card: {
        minWidth: 275,
        width: 'auto',
        margin: 'auto',
    },
    title: {
        fontSize: 14,
    },
}));


const DeviceLogShow = ({ permissions, ...props }) => {
    const classes = useStyles();
    const translate = useTranslate();
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    return (
        <div>
        { isSmall ? (
                <ShowController {...props} title=" ">
                {({ record }) => {
                    if (!record) return null; // Ensure something is returned
    
                    return (
                            <div className={classes.root}>
                                <Card className={classes.card}>
                                    <CardContent>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.serial_number_forn')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {record.serial_number_forn}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.mac_address')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {record.mac_address}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.impianto')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {record.impianto}
                                                </Typography>
                                            </Grid>
                                            {/* <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.impianto_regman')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.impianto_regman}
                                                </Typography>
                                            </Grid> */}
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <WithPermissions
                                                render={({ permissions }) =>
                                                    permissions === 'administrator' && <div>
                                                        <Grid className={classes.innergrid} item xs>
                                                            <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                                {translate('resources.devices.fields.codice_impresa_name')}
                                                            </Typography>
                                                            <Typography variant="body2" gutterBottom>
                                                                {record.codice_impresa_name}
                                                            </Typography>
                                                        </Grid>
                                                    </div>
                                                }
                                            />
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.cod_terr_sap')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.cod_terr_sap}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.num_consegna')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.num_consegna}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.cod_nmu')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.cod_nmu}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.cod_stato_uso.codice')}
                                                </Typography>
                                                <Typography
                                                    gutterBottom align="left" width="auto"
                                                    variant="body1"
                                                >
                                                    {record.cod_stato_uso ? record.cod_stato_uso.descrizione : undefined}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.tipo_famiglia')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {record.tipo_famiglia ? record.tipo_famiglia : 'Router'}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.cod_gruppo_tec')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {record.cod_gruppo_tec}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.cod_proj')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.cod_proj}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.client_type')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.client_type}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.associated_at')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.associated_at}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.associated_by')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.associated_by}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.sent_to_sap')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {returnDate(record.sent_to_sap)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.approved_at')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {returnDate(record.approved_at)}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.approved_by')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.approved_by}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.validated_at')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {returnDate(record.validated_at)}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.validated_by')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.validated_by}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.resource_id')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.resource_id}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.tipo_task')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.tipo_task}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.wr_prodotti')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.wr_prodotti.toString()}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.causale.codice')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.causale ? record.causale.descrizione : undefined}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.anomalia.descrizione')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.anomalia ? record.anomalia.descrizione : undefined}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.progetto_con_scarico')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.progetto_con_scarico}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.tipo_nmu')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.tipo_nmu}
                                                </Typography>
                                            </Grid>
                                            <WithPermissions
                                                render={({ permissions }) =>
                                                    (permissions === 'administrator' || permissions === 'approvatore' || permissions === 'dg') && <div>
                                                        <Grid className={classes.innergrid} item xs>
                                                            <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                                {translate('resources.devices.fields.codice_riscontro')}
                                                            </Typography>
                                                            <Typography variant="body2" gutterBottom>
                                                                {record.codice_riscontro}
                                                            </Typography>
                                                        </Grid>
                                                    </div>
                                                }
                                            />
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.wr_collaudo_one')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.wr_collaudo_one}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.impianto_collaudo_one')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.impianto_collaudo_one}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.data_collaudo_one')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {returnDate(record.data_collaudo_one)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.status_collaudo_one')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.status_collaudo_one ? record.status_collaudo_one.descrizione : undefined}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Card className={classes.card}>
                                    <CardContent>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                    {translate('resources.devices.fields.createdAt')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {returnDate(record.createdAt)}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom align="left">
                                                    {translate('resources.devices.fields.createdBy')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom align="left">
                                                    {record.createdBy}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.updatedBy')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {record.updatedBy}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </div>
                        );
                    }}
                </ShowController>
                ) : (
                <ShowController {...props} title=" ">
                {({ record }) => {
                    if (!record) return null; // Ensure something is returned
    
                    return  (
                            <div className={classes.root}>
                                <div style={{ margin: '4px 0' }}></div>
                                <Card className={classes.card}>
                                    <CardContent>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.serial_number_forn')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {record.serial_number_forn}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.impianto')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {record.impianto}
                                                </Typography>
                                            </Grid>
                                            {/* <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.impianto_regman')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.impianto_regman}
                                                </Typography>
                                            </Grid> */}
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.mac_address')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {record.mac_address}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.num_consegna')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.num_consegna}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.cod_nmu')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.cod_nmu}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.cod_stato_uso.codice')}
                                                </Typography>
                                                <Typography
                                                    gutterBottom align="left" width="auto"
                                                    variant="body1"
                                                >
                                                    {record.cod_stato_uso ? record.cod_stato_uso.descrizione : undefined}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.cod_proj')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.cod_proj}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.client_type')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.client_type}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.tipo_famiglia')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {record.tipo_famiglia ? record.tipo_famiglia : 'Router'}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.cod_gruppo_tec')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {record.cod_gruppo_tec}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>                                                
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.associated_at')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {returnDate(record.associated_at)}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.associated_by')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.associated_by}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.sent_to_sap')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {returnDate(record.sent_to_sap)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.approved_at')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {returnDate(record.approved_at)}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.approved_by')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.approved_by}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.validated_at')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {returnDate(record.validated_at)}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.validated_by')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.validated_by}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.resource_id')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.resource_id}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.tipo_task')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.tipo_task}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.wr_prodotti')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.wr_prodotti.toString()}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.causale.codice')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.causale ? record.causale.descrizione : undefined}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.anomalia.descrizione')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.anomalia ? record.anomalia.descrizione : undefined}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <div style={{ margin: '8px 0' }}></div>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.progetto_con_scarico')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.progetto_con_scarico}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.tipo_nmu')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.tipo_nmu}
                                                </Typography>
                                            </Grid>
                                            <WithPermissions
                                                render={({ permissions }) =>
                                                    (permissions === 'administrator' || permissions === 'approvatore' || permissions === 'dg') && <div>
                                                        <Grid className={classes.innergrid} item xs>
                                                            <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                                {translate('resources.devices.fields.codice_riscontro')}
                                                            </Typography>
                                                            <Typography variant="body2" gutterBottom>
                                                                {record.codice_riscontro}
                                                            </Typography>
                                                        </Grid>
                                                    </div>
                                                }
                                            />
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.wr_collaudo_one')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.wr_collaudo_one}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.impianto_collaudo_one')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.impianto_collaudo_one}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.data_collaudo_one')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {returnDate(record.data_collaudo_one)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.status_collaudo_one')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom>
                                                    {record.status_collaudo_one ? record.status_collaudo_one.descrizione : undefined}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <div style={{ margin: '10px 0' }}></div>
                                <Card className={classes.card}>
                                    <CardContent>
                                        <Grid container spacing={1}>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                    {translate('resources.devices.fields.createdAt')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {returnDate(record.createdAt)}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom align="left">
                                                    {translate('resources.devices.fields.createdBy')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom align="left">
                                                    {record.createdBy}
                                                </Typography>
                                            </Grid>
                                            <Grid className={classes.innergrid} item xs>
                                                <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                                    {translate('resources.devices.fields.updatedBy')}
                                                </Typography>
                                                <Typography variant="body2" gutterBottom >
                                                    {record.updatedBy}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <div style={{ margin: '4px 0' }}></div>
                            </div>
                        );
                    }}
                </ShowController>
                ) }
        </div>
    )};


function returnDate(field) {
    if (field !== undefined && field !== null) {
        return new Date(field).toLocaleString('it-IT');
    }
    else {
        return "";
    }
}
export default DeviceLogShow;